<div class="mt-4 mb-5" id="top">

  <div id="us_carousel" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img [src]="'assets/images/6.jpg'" class="d-block img-inner-center w-100" alt="1">

        <div class="d-none d-md-block">
          <div class="carousel-caption d-none d-md-block">
            <h1 class="mb-3 text-uppercase us_caption">{{"shared.about_us.title" | translate}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
<br>
  <div class="container-fluid">
    <div class="row justify-content-md-center">
      <div class="col-12 text-center">
        <h3>{{"shared.about_us.us" | translate}}</h3>
        <p class="translate-new-line">{{"shared.about_us.us_info_1" | translate}}<b>{{"shared.about_us.us_info_2" | translate: {program: programName} }}</b>{{"shared.about_us.us_info_3" | translate}}</p>
      </div>
    </div>
  </div>
</div>
